<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 48 48">
    <path fill="#FFA726" d="M12 16A5 5 0 1 0 12 26A5 5 0 1 0 12 16Z" />
    <path
      fill="#455A64"
      d="M2 34.7c0 0 2.8-6.3 10-6.3s10 6.3 10 6.3V38H2V34.7zM46 34.7c0 0-2.8-6.3-10-6.3s-10 6.3-10 6.3V38h20V34.7z"
    />
    <path fill="#FFB74D" d="M24 11A6 6 0 1 0 24 23A6 6 0 1 0 24 11Z" />
    <path
      fill="#607D8B"
      d="M36,34.1c0,0-3.3-7.5-12-7.5s-12,7.5-12,7.5V38h24V34.1z"
    />
    <path fill="#FFA726" d="M36 16A5 5 0 1 0 36 26A5 5 0 1 0 36 16Z" />
    <g>
      <path
        fill="#FFA726"
        d="M12 16A5 5 0 1 0 12 26 5 5 0 1 0 12 16zM36 16A5 5 0 1 0 36 26 5 5 0 1 0 36 16z"
      />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PeopleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
